module.exports = __webpack_public_path__ + "img/Catalogue@2x-100.c50b68e8.jpg";